import React from "react";

import "./Gallery.css";

const Gallery = ({ images, options, cssClass }) => {
  return (
    <div className={["module__gallery", cssClass].join(" ")}>
      <div className="grid">
        {images.map((image, index) => {
          return (
            <div
              className={`grid__item cell--${index + 1}`}
              key={index}
              tabIndex={image.caption.title ? "0" : null}
              role="button"
            >
              {image.image ? (
                <img
                  className="grid__item-image"
                  src={image.image.sourceUrl}
                  alt={image.image.altText}
                  title={image.image.title}
                />
              ) : null}
              {image.caption.title ? (
                <div className="gallery__caption">
                  <div className="caption__title">
                    <h3>{image.caption.title}</h3>
                  </div>
                  <p className="caption__description">
                    {image.caption.description}
                  </p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Gallery;
